import { Tooltip as MantineTooltip } from "@mantine/core";

export const Tooltip = MantineTooltip;
